"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.del = exports.patch = exports.put = exports.post = exports.get = exports.checkIfServerOnline = exports.extendConfig = exports.ERROR_NETWORK_DISCONNECTED = exports.ERROR_SERVER_UNREACHABLE = exports.apiPath = void 0;

var _localforage = _interopRequireDefault(require("localforage"));

var _axios = _interopRequireDefault(require("axios"));

var _axiosCacheAdapter = require("axios-cache-adapter");

var _authentication = require("../authentication");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var apiPath = 'api/v1';
exports.apiPath = apiPath;
var DEFAULT_MAX_AGE = 1000;
var SERVER_ONLINE_STATUS = 200;
var ERROR_SERVER_UNREACHABLE = 'ERR_SERVER_UNREACHABLE';
exports.ERROR_SERVER_UNREACHABLE = ERROR_SERVER_UNREACHABLE;
var ERROR_NETWORK_DISCONNECTED = 'ERR_NETWORK_DISCONNECTED';
exports.ERROR_NETWORK_DISCONNECTED = ERROR_NETWORK_DISCONNECTED;

var cacheStore = _localforage.default.createInstance({
  driver: [_localforage.default.INDEXEDDB],
  name: 'web-cache'
});

var api = (0, _axiosCacheAdapter.setup)({
  crossDomain: true,
  cache: {
    store: cacheStore,
    maxAge: 1 * 1 * 1 * 1 * DEFAULT_MAX_AGE,
    exclude: {
      query: false
    },
    key: function key(req) {
      var serialized = req.params instanceof URLSearchParams ? req.params.toString() : JSON.stringify(req.params) || '';
      return req.url + serialized;
    }
  }
});

var extendConfig = function extendConfig(config) {
  var headers = _objectSpread({}, config.headers);

  if (config && config.token) {
    var authHeaders = (0, _authentication.authorizationHeaders)({
      token: config.token
    });
    headers = _objectSpread({}, config.headers, {}, authHeaders);
  }

  var _config = _objectSpread({
    baseURL: config.server
  }, config, {
    headers: headers
  });

  return _config;
};

exports.extendConfig = extendConfig;

var checkIfServerOnline = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(serverUrl) {
    var response, serverIsResponding, errorMessage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (navigator.onLine) {
              _context.next = 2;
              break;
            }

            throw new Error(ERROR_NETWORK_DISCONNECTED);

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return _axios.default.get("".concat(serverUrl, "/").concat(apiPath, "/version"));

          case 5:
            response = _context.sent;
            serverIsResponding = response.status === SERVER_ONLINE_STATUS;

            if (serverIsResponding) {
              _context.next = 9;
              break;
            }

            throw new Error(ERROR_SERVER_UNREACHABLE);

          case 9:
            _context.next = 19;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            errorMessage = _context.t0 && _context.t0.message ? _context.t0.message : '';

            if (!errorMessage.match(/network error/ig)) {
              _context.next = 18;
              break;
            }

            throw new Error(ERROR_SERVER_UNREACHABLE);

          case 18:
            throw _context.t0;

          case 19:
            ;

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 11]]);
  }));

  return function checkIfServerOnline(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.checkIfServerOnline = checkIfServerOnline;

var get = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var url, params, config, noCache, _config, response, _params, data;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = _ref2.url, params = _ref2.params, config = _ref2.config, noCache = _ref2.noCache;
            _config = config ? extendConfig(config) : {};
            _context2.prev = 2;

            if (!noCache) {
              _context2.next = 10;
              break;
            }

            _params = _objectSpread({
              noCache: Math.random()
            }, params);
            _context2.next = 7;
            return _axios.default.get(url, _objectSpread({}, _config, {
              params: _params
            }));

          case 7:
            response = _context2.sent;
            _context2.next = 13;
            break;

          case 10:
            _context2.next = 12;
            return api.get(url, _objectSpread({}, _config, {
              params: params
            }));

          case 12:
            response = _context2.sent;

          case 13:
            _context2.next = 19;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](2);
            _context2.next = 19;
            return checkIfServerOnline(config.server);

          case 19:
            data = response ? response.data : null;
            return _context2.abrupt("return", data);

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 15]]);
  }));

  return function get(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

exports.get = get;

var post = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
    var url, payload, config, _config, _yield$_axios$default, data;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = _ref4.url, payload = _ref4.payload, config = _ref4.config;
            _config = extendConfig(config);
            _context3.next = 4;
            return _axios.default.post(url, payload, _config);

          case 4:
            _yield$_axios$default = _context3.sent;
            data = _yield$_axios$default.data;
            return _context3.abrupt("return", data);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function post(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

exports.post = post;

var put = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref6) {
    var url, payload, config, _config, _yield$_axios$default2, data;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            url = _ref6.url, payload = _ref6.payload, config = _ref6.config;
            _config = extendConfig(config);
            _context4.next = 4;
            return _axios.default.put(url, payload, _config);

          case 4:
            _yield$_axios$default2 = _context4.sent;
            data = _yield$_axios$default2.data;
            return _context4.abrupt("return", data);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function put(_x4) {
    return _ref7.apply(this, arguments);
  };
}();

exports.put = put;

var patch = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref8) {
    var url, payload, config, _config, _yield$_axios$default3, data;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            url = _ref8.url, payload = _ref8.payload, config = _ref8.config;
            _config = extendConfig(config);
            _context5.next = 4;
            return _axios.default.patch(url, payload, _config);

          case 4:
            _yield$_axios$default3 = _context5.sent;
            data = _yield$_axios$default3.data;
            return _context5.abrupt("return", data);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function patch(_x5) {
    return _ref9.apply(this, arguments);
  };
}();

exports.patch = patch;

var del = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref10) {
    var url, payload, config, _config, _yield$_axios$default4, data;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = _ref10.url, payload = _ref10.payload, config = _ref10.config;
            _config = extendConfig(config);
            _config.data = payload;
            _context6.next = 5;
            return _axios.default.delete(url, _config);

          case 5:
            _yield$_axios$default4 = _context6.sent;
            data = _yield$_axios$default4.data;
            return _context6.abrupt("return", data);

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function del(_x6) {
    return _ref11.apply(this, arguments);
  };
}();

exports.del = del;